var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15838 10.9306C0.445374 9.74229 0.445374 8.25771 1.15838 7.06937C1.37596 6.70674 1.73641 6.45272 2.1511 6.36978L3.84413 6.03117C3.94499 6.011 4.03591 5.95691 4.10176 5.87788L6.17085 3.39498C7.3534 1.97592 7.94468 1.26638 8.47234 1.45742C9 1.64846 9 2.57207 9 4.41928L9 13.5807C9 15.4279 9 16.3515 8.47234 16.5426C7.94468 16.7336 7.3534 16.0241 6.17085 14.605L4.10176 12.1221C4.03591 12.0431 3.94499 11.989 3.84413 11.9688L2.1511 11.6302C1.73642 11.5473 1.37596 11.2933 1.15838 10.9306Z",
    fill: "#497A98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L18 6",
    stroke: "#497A98",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L12 6",
    stroke: "#497A98",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.2948705dfc4c18ba5cb61776a29b0b2e.svg";
export { ForwardRef as ReactComponent };